import React from "react";
import { ORG } from "../../data/costant";

export default function Facts() {
  return (
    <div className="container-xxl py-5">
      <div className="container py-5">
        <div className="row g-5">
          {/* Left Column */}
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="text-secondary text-uppercase mb-3">Some Facts</h6>
            <h1 className="mb-5">#1 Place To Manage All Of Your Shipments</h1>
            <p className="mb-5">
              I wanted to share some exciting information about our service that
              I think could really benefit your shipping management. We offer a
              streamlined platform to handle all of your transport needs, making
              it easier than ever to keep track of your shipments in one
              convenient place. Our solution is designed to enhance efficiency
              and simplify your logistics process. We're confident it will save
              you time and give you greater peace of mind when managing your
              logistics.
            </p>
            <div className="d-flex align-items-center">
              <i className="fa fa-headphones fa-2x flex-shrink-0 bg-primary p-3 text-white"></i>
              <div className="ps-4">
                <h6>Call for any query!</h6>
                <h3 className="text-primary m-0">+91 {ORG.mobile}</h3>
              </div>
            </div>
          </div>
          {/* Right Column */}
          <div className="col-lg-6">
            <div className="row g-4 align-items-center">
              <div className="col-sm-6">
                <div
                  className="bg-primary p-4 mb-4 wow fadeIn"
                  data-wow-delay="0.3s"
                >
                  <i className="fa fa-users fa-2x text-white mb-3"></i>
                  <h2 className="text-white mb-2" data-toggle="counter-up">
                    18000+
                  </h2>
                  <p className="text-white mb-0">Happy Clients</p>
                </div>
                <div
                  className="bg-secondary p-4 wow fadeIn"
                  data-wow-delay="0.5s"
                >
                  <i className="fa fa-ship fa-2x text-white mb-3"></i>
                  <h2 className="text-white mb-2" data-toggle="counter-up">
                    102000+
                  </h2>
                  <p className="text-white mb-0">Complete Shipments</p>
                </div>
              </div>
              <div className="col-sm-6">
                <div
                  className="bg-success p-4 wow fadeIn"
                  data-wow-delay="0.7s"
                >
                  <i className="fa fa-star fa-2x text-white mb-3"></i>
                  <h2 className="text-white mb-2" data-toggle="counter-up">
                    7000+
                  </h2>
                  <p className="text-white mb-0">Happy Drivers & Owners</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
